import { render, staticRenderFns } from "./ReservationRequestShow.vue?vue&type=template&id=38a810d9&scoped=true&"
import script from "./ReservationRequestShow.vue?vue&type=script&lang=js&"
export * from "./ReservationRequestShow.vue?vue&type=script&lang=js&"
import style0 from "./ReservationRequestShow.vue?vue&type=style&index=0&id=38a810d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a810d9",
  null
  
)

export default component.exports